module.exports = __webpack_public_path__ + "img/744.cd80aca8.jpg";